import structuredClone from '@ungap/structured-clone';
import * as $ from "jquery";

Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

/**
 * Is the given value a string?
 * @param obj {*} The given value
 * @return {boolean} true if it is
 */
function isString(obj) {
    return (Object.prototype.toString.call(obj) === '[object String]');
}

/**
 * Is the given value a function?
 * @param obj {*} The given value
 * @return {boolean}
 */
function isFunction(obj) {
    return Object.prototype.toString.call(obj) === '[object Function]';
}

/**
 * Validate an email address with a regular expression
 * @param email {string}
 * @return {boolean}
 */
function validateEmail(email) {
    return !!String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

/**
 * Given a URL return the same without the last directory
 * @param url {string}
 * @param includeParams {boolean}
 * @return {string}
 */
function removeLastDirectoryFromUrl(url, includeParams = false) {
    const split = url.split('?');
    const hasParams = split.length > 1;
    const dirPart = split[0];
    const arr = dirPart.split('/');
    if (dirPart.endsWith('/'))
        arr.pop();
    arr.pop();
    return arr.join('/') + (includeParams ? ('?' + (hasParams ? split[1] : '')) : '');
}

/**
 * Remove tags form a string
 * @param txt {string}
 * @return {string}
 */
function stripTags(txt) {
    if (!txt || txt.length === 0)
        return txt;
    return $("<div><div/>").html(txt).text();
}

function hyperlinkURLs(message) {
    message = nnTrim(message);
    if (!message) return;

    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
        let hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
            hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" target="_blank">' + url + '</a>'
    });
}

String.prototype.includesIgnoringSpecial = function (what) {
    const trimmedWat = nnTrim(what);
    if (!trimmedWat)
        return false;
    const normalize = toNormalize => toNormalize.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalized = normalize(String(this).toLowerCase());
    const normalizedWhat = normalize(trimmedWat.toLowerCase());
    return normalized.includes(normalizedWhat);
}

function nnTrim(obj, orElse = undefined) {
    const trimmed = obj !== undefined && obj !== null
        ? obj.toString().trim()
        : undefined;
    return trimmed && trimmed.length > 0
        ? trimmed
        : orElse !== undefined && orElse !== null ? (isFunction(orElse) ? orElse() : orElse) : orElse;
}

String.prototype.crop = function (size) {
    return (this.length <= size
        ? this
        : this.substring(0, size - 3) + '...').toString();
}

String.prototype.format = function () {
    const args = arguments;
    return this.replace(/\{(\d+)\}/g, function (a) {
        return args[0][parseInt(a.match(/(\d+)/g))];
    });
};

Number.prototype.round = function (decimals = 0) {
    decimals = Math.round(decimals);
    const upDown = Math.pow(10, decimals);
    return Math.round((this + Number.EPSILON) * upDown) / upDown;
};

/**
 * Format a number
 * @param number {number} The number to format
 * @param decimals {number} integer, the nr of decimals
 * @param unit {string} The unit to append to the formatted nr (can be undefined)
 * @return {string} The formatted nr
 */
function formatNumber(number, decimals = 0, unit = undefined) {
    return isNumber(number) ?
        number.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }) + (unit ? ' ' + unit : '')
        : '--';
}

/**
 * String to number
 * @param str {string}
 * @return {number|*}
 */
function toNumber(str) {
    return isNumber(str) ? str : (str !== null && str !== undefined ? Number(str) : str);
}

/**
 * Is the given value a number?
 * @param value {*} The given value
 * @return {boolean} true if it is
 */
function isNumber(value) {
    return value !== null && value !== undefined && typeof value === 'number' && isFinite(value);
}

/**
 * Is the given value a boolean?
 * @param value {*} The given value
 * @return {boolean|undefined|null} true if it is, false if isn't, undefined if undefined, null if null
 */
function isBoolean(value) {
    if (value === undefined || value === null)
        return value;
    return value === true || value === false;
}


/**
 * get a random nr from the given interval
 * @param min {number}
 * @param max {number}
 * @return {number}
 */
function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * get a random integer from the given interval
 * @param min {number} (integer)
 * @param max {number} (integer)
 * @return {number} (integer)
 */
function getRandomInteger(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}

/**
 * get a random string from the given array
 * @param strings {Array<string>}
 * @return {string}
 */
function getRandomStr(strings) {
    return strings[getRandomInteger(0, strings.length - 1)];
}

/**
 * Clone an object or array
 * @param obj {any}
 * @return {any}
 */
function clone(obj) {
    return structuredClone(obj);
}

/**
 * Prefix a URL if needed
 * @param prefix {string}
 * @param url {string}
 */
function prefixUrl(url, prefix = tumbo.serviceUrlPrefix) {
    prefix = nnTrim(prefix);
    url = nnTrim(url);
    if (!prefix || !url)
        return url;
    const fixedPrefix = (prefix.indexOf("http") === 0 ? '' : '//') + prefix;
    return (url.indexOf('//') === 0 || url.indexOf('http://') === 0 || url.indexOf('https://') === 0
        ? url
        : fixedPrefix + (url && url.indexOf("/") === 0 ? '' : '/') + url).replace('////', '//');
}

/**
 * Download from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param newTab {boolean} if true, a new tab is opened for the download
 * @param name {string} The name of the file to prefill the download dialog
 */
function downloadFromUrl(url, newTab = false, name = undefined) {
    const a = document.createElement('A');
    a.style = 'display:none;';
    a.href = url;
    if (newTab)
        a.target = '_blank'
    if (name)
        a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/**
 * Download an image from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param name {string} The name of the file to prefill the download dialog
 */
async function downloadImageFromUrl(url, name = undefined) {
    const image = await fetch(url)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)

    const a = document.createElement('A');
    a.style = 'display:none;';
    a.href = imageURL;
    if (name)
        a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/**
 * Given a sorted array of numbers, calculate a given quantile
 * @param sortedArray {Array<number>} The sorted asc array
 * @param q {number} The quantile to calculate [0..1]
 * @return {number}
 */
function quantile(sortedArray, q) {
    const pos = (sortedArray.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sortedArray[base + 1] !== undefined) {
        return sortedArray[base] + rest * (sortedArray[base + 1] - sortedArray[base]);
    } else {
        return sortedArray[base];
    }
}

/**
 * Calculate the mean of an array of numbers
 * @param array {Array<number>}
 * @return {number}
 */
function mean(array) {
    return (array.reduce((sum, current) => sum + current)) / array.length;
}

/**
 * The variance of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */
function variance(values) {
    const average = mean(values);
    const squareDiffs = values
        .map((value) => Math.pow(value - average, 2));
    return mean(squareDiffs);
}

/**
 * The standard deviation of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */
function stddev(values) {
    return Math.sqrt(variance(values));
}

function arrayRange(from, to) {
    return [...Array(to - from + 1).keys()].map(v => v + from);
}

function arrayLast(arr){
    return arr?arr[arr.length-1]:undefined;
}

export {
    isString,
    isFunction,
    isBoolean,
    validateEmail,
    removeLastDirectoryFromUrl,
    hyperlinkURLs,
    stripTags,
    nnTrim,
    toNumber,
    isNumber,
    getRandomNumber,
    getRandomInteger,
    getRandomStr,
    formatNumber,
    clone,
    prefixUrl,
    downloadFromUrl,
    downloadImageFromUrl,
    mean,
    quantile,
    variance,
    stddev,
    arrayRange,
    arrayLast
}